import { Component, Input, OnInit } from '@angular/core';
import { MdDialogRef } from '@angular/material';
import { UtilitiesService } from 'app/services/utilities/utilities.service';

@Component({
  selector: 'act-dialog-alert-pin',
  templateUrl: './dialog-alert-pin.component.html',
  styleUrls: ['./dialog-alert-pin.component.scss']
})
export class DialogAlertPinComponent implements OnInit {

  public isMobile = false;
  public elementId: string = 'dialog-alert-pin';
  public imageSrc: string = '/assets/images/icons/icon-failed.png';

  constructor(
    private dialogRef: MdDialogRef<DialogAlertPinComponent>,
    private utilitiesService: UtilitiesService,
  ) {
    this.isMobile = this.utilitiesService.isMobile();
  }

  ngOnInit(): void {}

  handleSubmit(): void {
    this.dialogRef.close({confirm : true});
  }

  handleClose(): void {
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/modal/dialog-pin/dialog-alert-pin/dialog-alert-pin.component.ts